import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/dialogService/dialog-service';
import { IProfile } from 'src/app/shared/profile.model';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { LanguageService } from 'src/app/services/languageService/language.service';

@Component({
  selector: 'app-switch-profile',
  templateUrl: './switch-profile.component.html',
  styleUrls: ['./switch-profile.component.less']
})
export class SwitchProfileComponent implements OnInit {
  features = environment.features;
  profiles: IProfile[];
  currentProfile;
  private pinDialogRef;
  constructor(public dialogRef: MatDialogRef<SwitchProfileComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private dialogService: DialogService, private subscriberService: SubscriberService, private router: Router, private languageService: LanguageService) { }

  ngOnInit() {
    this.getProfiles();
  }

  // Get profiles from platform
  getProfiles() {
    this.subscriberService.getProfiles().then((resp: any) => {
      this.profiles = resp.data.profiles;

      this.currentProfile = this.data.userService.getUser();
      // Check features
      if (!this.features.hasProfiles) {
        this.switchProfile(this.profiles[0]);
      }
    });
  }

  // Select profile
  selectProfile(profile) {
    if (profile?.pinEnabled) {
      this.pinDialogRef = this.dialogService.openInputDialog({
        title: "gen_switch_profile",
        message: "gen_profile_password_msg",
        confirm: "gen_ok",
        cancel: "gen_cancel",
        type: "password",
        inputTitle: "PIN",
        returnType: "onSubmit",
        rules: {
          regex: "[0-9]{5,5}",
          required: true
        }
      });
      this.pinDialogRef.componentInstance.onSubmit.subscribe(resp => {
        if (resp?.value) {
          profile["pin"] = resp.value;
          this.switchProfile(profile);
        }
      });
    } else {
      this.switchProfile(profile);
    }
  }

  /** Switch profile API call  */
  switchProfile(profile) {
    let req = {
      id: profile.id,
      language: profile.language
    }

    if (profile?.pin) {
      req["pin"] = profile.pin;
    }
    this.subscriberService.switchProfile(req, this.data.userService).then(resp => {
      this.data.userService.setUser(profile);
      // Update Token
      this.data.userService.getToken().then(respToken => {
        if (this.pinDialogRef) {
          this.pinDialogRef.close();
        }
        this.data.userService.getLoggedInStatus.next(true);
        this.router.navigate(["/home"]);
        this.dialogRef.close(profile);
      });
    });
  }

  // Delete Profile
  deleteProfile(profile) {
    this.dialogService.openConfirmDialog({
      title: "gen_delete_profile",
      message: "info_delete_profile_msg",
      confirm: "gen_ok",
      cancel: "gen_cancel"
    }).subscribe(result => {
      if (result) {
        this.subscriberService.deleteProfile({ id: profile.id }).then((resp: any) => {
          this.ngOnInit();
        });
      }
    });
  }

  // Add Profile
  addProfile() {
    // To Do implement pin protection during create profile
    this.dialogService.openInputDialog({
      icon: "fa fa-user-plus",
      title: "gen_create_profile",
      confirm: "gen_save",
      cancel: "gen_cancel",
      type: "text",
      inputTitle: "gen_profile_name",
      returnType: "afterClosed",
      value: "",
      rules: {
        required: true
      }
    }).afterClosed().subscribe(resp => {
      if (resp?.value) {
        console.log(resp.value);
        this.subscriberService.createProfile({
          type: "1",
          displayName: resp.value,
          avatar: 0,
          rating: 4,
          language: this.languageService.getLanguage(),
          pinEnabled: false,
          pin: null
        }).then(resp => this.ngOnInit());
      }
    });
  }

  // Edit Profile
  editProfile(profile) {
    this.dialogService.openProfileDialog(profile).subscribe(result => {
      if (result) {
        this.ngOnInit();
      }
    });
  }
}